import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { SupplierFieldsProps } from 'checkout/types/supplierFieldsTypes';

const initialState: SupplierFieldsProps[] = [];

const supplierFieldsSlice = createSlice({
  name: 'supplierFields',
  initialState,
  reducers: {
    setSupplierFieldsData: (
      _: SupplierFieldsProps[],
      action: PayloadAction<SupplierFieldsProps[]>,
    ) => action.payload,
  },
});

export const { setSupplierFieldsData } = supplierFieldsSlice.actions;

const { name, reducer } = supplierFieldsSlice;
export { reducer as default, name };
